import EventType from 'ol/events/EventType';

import { CLASS_CONTROL, CLASS_UNSELECTABLE } from 'ol/css';
import Control from 'ol/control/Control';

import { getMinResolution } from '../scale_util';

import { faSearch } from '@fortawesome/pro-solid-svg-icons'
import { icon } from '@fortawesome/fontawesome-svg-core'
import { listen } from 'ol/events';
import { unByKey } from 'ol/Observable';

import './search.css';

class Search extends Control {

	constructor( opt_options ) {
		const options = opt_options ? opt_options : {};	
		super({
      		element: document.createElement('div'),
      		render: options.render,
      		target: options.target
    	});		
    		
    	this.geocoder = options.geocoder;
    	this.minResolution = options.minResolution;
    		
		const className = options.className !== undefined ? options.className : 'ol-search';
		const containerElement = this.element;
		
		containerElement.className = `${className} ${CLASS_UNSELECTABLE} ${CLASS_CONTROL}`;
		
		const inputBox = document.createElement('div');
		inputBox.className = "search-box";
		
		containerElement.appendChild(inputBox);
		
		const inputElement = document.createElement('input');
		inputElement.className = 'search';
		inputElement.autocomplete = "off";
		inputElement.placeholder = options.emptyText;
		inputBox.appendChild(inputElement);
		
		this.inputElement = inputElement;
		
		const searchButton = document.createElement('button');
		searchButton.className = 'search';

		const i = icon(faSearch);
		Array.from(i.node).map(n => searchButton.appendChild(n));
		inputBox.appendChild(searchButton);
		
		this.searchButton = searchButton;
		
		const listElement = document.createElement('div');
		listElement.className = 'list';
		this.listElement = listElement;
		
		containerElement.appendChild(listElement);
		
		inputElement.addEventListener("keyup", (event) => this.changeValue(event));
	}
	
	setMap(map) {
		super.setMap(map);
		this.geocoder.setMap(map);
		this.minResolution = getMinResolution(map.getView().getProjection());
	}	
	
	changeValue(event) {
		clearTimeout(this.typeDelay);		
		this.typeDelay = setTimeout(() => this.updateValue(), 250);
	}
	
	async updateValue() {
		const parent = this.listElement;
		parent.innerHTML = "";
		
		if( this.inputElement.value ) {
			const values = await this.geocoder.search(this.inputElement.value, this.getMap());
			
			values.forEach(value => {
				const element = document.createElement("div");
				element.innerHTML = value.name;
				parent.appendChild(element);
				
				element.addEventListener(EventType.CLICK, event => this.selectValue(value));
			})			
		}
		
	}
	
	async selectValue(value) {
		const { name } = value;		
		
		const geometry = this.geocoder.geometry( value );
		
		this.listElement.innerHTML = "";
		this.inputElement.value = name;	
			
		this.getMap().getView().fit(geometry, {
			duration: 750,
			minResolution: this.minResolution,
			constrainResolution: true
		});
	}
	
	setActive(active) {
		const classList = this.searchButton.classList;
		if( active ) {
			classList.add('active');
		} else {
			classList.remove('active');
		}
	}
	
	addSearchHandler(handler) {
		const key = listen(this.searchButton, EventType.CLICK, event => {
			handler();
		})		

		return () => unByKey(key);	
	}

}

export {
	Search
}

